import { ArrowLeft, ChevronRight, LogOut, Settings, ShoppingBag, User } from "lucide-react";
import React from "react";
import { Link } from "react-router-dom";
import LogoutMobileButton from "./LogoutMobileButton";
import { useAuth } from "../context/AuthContext"; // Adjust the path to your AuthContext
import mobProf from "../assets/mobProfile.png"; // Update the path if needed mobOrder.png
import mobOrder from "../assets/mobOrder.png"; // Update the path if needed mobOrder.png

export default function MobileProfileManagement() {
  const { token, isAdmin, logout } = useAuth(); // Access authentication details

  return (
    <div className="min-h-screen lg:bg-bg-[#191919]  bg-[#191919] p-4 text-white lg:hidden">
      {/* Header */}

      {/* Manage Section */}
      <div className="mb-6">
        <h3 className=" text-primary mb-10">Manage</h3>
        <div className="rounded-2xl bg-primary p-4">
          {/* Account Settings */}
          <Link to="/manageAccount" className="flex w-full items-center justify-between py-2">
            <div className="flex items-center gap-3">
              <img src={mobProf} className="h-5 w-5" />
              <span className="text-black">Account settings</span>
            </div>
            <ChevronRight className="h-5 w-5 text-black" />

          </Link>
          <Link to="/track-order" className="flex w-full items-center justify-between py-2">
            <div className="flex items-center gap-3">
              <img src={mobOrder} className="h-5 w-5" />
              <span className="text-black">Orders</span>
            </div>
            <ChevronRight className="h-5 w-5 text-black" />
          </Link>

          {/* Admin Link */}
          {isAdmin && (
            <Link to="/admin/admin-orderlists" className="flex w-full items-center justify-between py-2">
              <div className="flex items-center gap-3">
                <Settings className="h-5 w-5 text-black" />
                <span className="text-black">Admin</span>
              </div>
              <ChevronRight className="h-5 w-5 text-black" />
            </Link>
          )}
        </div>
      </div>

      {/* Logout Button */}
      <button className="flex mt-10 w-full items-center justify-center gap-2 rounded-full bg-primary py-4 text-black">
        <LogoutMobileButton />
      </button>
    </div>
  );
}
